module.exports = __webpack_public_path__ + "static/media/calculator.f76c70dc.svg";